const ERROR = { error: true };

const SCRIPT_DOMAIN = {
  co: 'https://resources.openpay.co/',
  mx: 'https://js.openpay.mx/',
  pe: 'https://js.openpay.pe/',
};

const SCRIPT_DATA_ID = 'openPayData';

const SCRIPT_DATA_NAME = 'openpay-data.v1.min.js';

const SCRIPT_ID = 'openPay';

const SCRIPT_NAME = 'openpay.v1.min.js';

export { ERROR, SCRIPT_DATA_ID, SCRIPT_DATA_NAME, SCRIPT_DOMAIN, SCRIPT_ID, SCRIPT_NAME };
